// import { useEffect } from "react";
// import '../index.css'

// function GoogleTranslate() {
//   window.addEventListener("click", (e) => {
//     if (e.target.value === "ar") {
//       window.location.reload();
//     }
//   });
//   useEffect(() => {
//     const script = document.createElement("script");
//     script.type = "text/javascript";
//     script.src =
//       "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
//     document.body.appendChild(script);

//     window.googleTranslateElementInit = () => {
//       new window.google.translate.TranslateElement(
//         {
//           pageLanguage: "ar",
//           includedLanguages: "en,ar",
//         },
//         "google_translate_element"
//       );
//     };
//     return () => {
//       document.body.removeChild(script);
//       delete window.googleTranslateElementInit;
//     };
//   }, []);

//   return (
//     <div className="relative">
//       <div id="google_translate_element"></div>
//       <i className="fa-solid fa-globe text-[#fffff] absolute top-[50%] translate-y-[-50%] right-3"></i>
//     </div>
//   );
// }

// export default GoogleTranslate;

import { useEffect } from "react";
import "./googleTranslate.css";

const GoogleTranslate = ({ onClose }) => {
  const handleLangChange = (lang) => {
    const select = document.querySelector(".goog-te-combo");
    if (!select) return;

    select.value = lang;
    select.dispatchEvent(new Event("change"));

    onClose();
  };

  useEffect(() => {
    if (document.getElementById("google-translate-script")) return;

    window.googleTranslateElementInit = () => {
      new window.google.translate.TranslateElement(
        {
          pageLanguage: "ar",
          includedLanguages: "ar,en",
          autoDisplay: false,
        },
        "google_translate_element"
      );
    };

    const script = document.createElement("script");
    script.id = "google-translate-script";
    script.src =
      "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <div className="lang-popup">
      <button className="close-btn" onClick={onClose}>✕</button>

      <div id="google_translate_element" style={{ display: "none" }} />

      <div className="lang-switch">
        <button onClick={() => {
              const select = document.querySelector(".goog-te-combo");
    if (!select) return;

    select.value = "ar";
    select.dispatchEvent(new Event("change"));
          window.location.reload()}}>AR</button>
        <button onClick={() => handleLangChange("en")}>EN</button>
      </div>
    </div>
  );
};

export default GoogleTranslate;




// import { useEffect } from "react";
// import "./googleTranslate.css";

// const GoogleTranslate = () => {

//   const setLang = (lang) => {
//   const select = document.querySelector(".goog-te-combo");
//   if (!select) return;

//   select.value = lang;
//   select.dispatchEvent(new Event("change"));
// };

//   useEffect(() => {
//     // منع تحميل السكربت أكتر من مرة
//     if (document.getElementById("google-translate-script")) return;

//     window.googleTranslateElementInit = () => {
//       new window.google.translate.TranslateElement(
//         {
//           pageLanguage: "ar",
//           includedLanguages: "ar,en",
//           autoDisplay: false,
//         },
//         "google_translate_element"
//       );
//     };

//     const script = document.createElement("script");
//     script.id = "google-translate-script";
//     script.src =
//       "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
//     script.async = true;
//     document.body.appendChild(script);

//     return () => {
//       delete window.googleTranslateElementInit;
//     };
//   }, []);

//   return (
//     <div className="google-lang">
//       {/* <span className="icon">🌐</span>
//       <div id="google_translate_element"></div> */}

//       <div className="lang-switch">
//   <button onClick={() => setLang("ar")}>AR</button>
//   <button onClick={() => setLang("en")}>EN</button>
// </div>

//     </div>
//   );
// };

// export default GoogleTranslate;
